import { DASH_SYMBOL } from 'app/consts'
import { DeviceCardSeparator, PropertyTitle } from '../styles'

interface DeviceWhiteCardSectionProps {
  title: string
  value: string
}

function DeviceWhiteCardSection({ title, value }: DeviceWhiteCardSectionProps) {
  if (!value || value === DASH_SYMBOL) return null

  return (
    <DeviceCardSeparator>
      <PropertyTitle>{title}</PropertyTitle>
      <span>{value}</span>
    </DeviceCardSeparator>
  )
}

export default DeviceWhiteCardSection
